export interface EventViewSettings {
  viewingId: number;
  eventData: [
    {
      coverView?: any;
      id: Number;
      name?: any;
      description?: any;
      endDate?: String;
      requirement?: String;
      price: any;
      startDate: any;
    },
  ];
}
export default {
} as EventViewSettings;

export const spaceName = 'caEvent';
